export const SOUND_FILES = {
  click: ["ui-click"], select: ["ui-select"], pickup: ["cargo-received"],
  warning: ["hull-warning"], ability: ["module-activate"], repair: ["repair"],
  pulse: ["pulse", "pulse-b", "pulse-c"], laser: ["laser", "laser-b", "laser-c"],
  missile: ["missile", "missile-b", "missile-c"], flak: ["flak", "flak-b", "flak-c"],
  rail: ["rail", "rail-b", "rail-c"], ion: ["ion", "ion-b", "ion-c"],
  mine: ["mine", "mine-b", "mine-c"], shield: ["shield-hit", "shield-hit-b", "shield-hit-c"],
  hull: ["hull-hit", "hull-hit-b", "hull-hit-c"], explosion: ["explosion"], launch: ["launch"],
  dock: ["dock"], jump: ["jump"], engine: ["engine"],
} as const;

export type SoundId = keyof typeof SOUND_FILES;
export type MusicScene = "station" | "exploration" | "danger" | "combat";
export const MUSIC_FILES: Record<MusicScene, string> = {
  station: "safe-harbor", exploration: "last-signal", danger: "ghosts-of-the-rift", combat: "contact",
};
export interface SoundCue {
  id: SoundId;
  gain: number;
  pan: number;
}

export function weaponSound(kind: string): SoundId {
  switch (kind) {
    case "laser": case "missile": case "flak": case "rail": case "ion": case "mine":
      return kind;
    default: return "pulse";
  }
}
